import { createSelector } from 'reselect';

export const isLoggedIn = createSelector(
  [state => state.session.loggedIn, state => state.session.user],
  (loggedIn, user) => loggedIn && user
);
